import { render } from "./CodeBlock.vue?vue&type=template&id=4cbd9db2&ts=true"
import script from "./CodeBlock.vue?vue&type=script&lang=ts"
export * from "./CodeBlock.vue?vue&type=script&lang=ts"

import "./CodeBlock.vue?vue&type=style&index=0&id=4cbd9db2&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__